// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const skillsClient = createTypedClient();
export const createSkillsClient = (config) => createTypedClient(config);
